__turbopack_context__.v({
  "logo": "Logo-module__EiO4Aq__logo",
});
